import React, { Component } from "react";
import { flushSync } from "react-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button } from "devextreme-react";
import DateBox from "devextreme-react/date-box";
import { AxiosResponse } from "axios";
import LookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
import sharedUtils from "../grid/sharedUtilities";
import DropDownFromLookupTableDynamic from "../select/SelectBoxFromLookupTableDynamic";
import { LookUpOnValueChangedEvent, SelectBoxOnValueChangedEvent } from "../../types/DevExtremeTypes";
import LookupTypeListDynamic from "../select/LookupTypeListDynamic";
import MatrixGridService from "../../services/MatrixService";

interface VenueCalendarPageSidebarPanelProps extends WithTranslation {
    onApplyButtonClick: () => void;
    setServiceTypeId: (id: string) => void;
    setClientId: (id: string) => void;
    setVenueId: (id: string) => void;
    setDateFrom: (date: Date) => void;
    setClientStartDayOfWeekId: (id: number) => void;
    clientId: string;
    venueId: string;
    serviceTypeId: string;
    dateFrom: Date | null;
}

class VenueCalendarPageSidebarPanel extends Component<
    VenueCalendarPageSidebarPanelProps
> {
    lookupService: LookupService;
    sharedUtils: sharedUtils;
    matrixGridService: MatrixGridService;
    constructor(props: VenueCalendarPageSidebarPanelProps) {
        super(props);
        this.lookupService = new LookupService();
        this.sharedUtils = new sharedUtils();
        this.matrixGridService = new MatrixGridService();
    }

    handleChangeClientTypeSelect = (e: LookUpOnValueChangedEvent) => {
        this.props.setClientId(e.value);
        this.matrixGridService
            .getClientStartDayOfWeek(e.value)
            .then((res: any) => this.handleSuccessSetClientFirstDayOfWeek(res))
            .catch(this.handleStandardError);
    };

    handleSuccessSetClientFirstDayOfWeek = (res: AxiosResponse<any>) => {
        this.props.setClientStartDayOfWeekId(res?.data?.data.daysOfWeekId ? res?.data?.data.daysOfWeekId : 0);
    };

    handleStandardError = (error: any) => {
        var respMessage: string = JSON.stringify(error);
        console.error(respMessage);
    };
    handleChangeVenueTypeSelect = (e: LookUpOnValueChangedEvent) => {
        this.props.setVenueId(e.value);
    };

    handleChangeServiceTypeSelect = (e: SelectBoxOnValueChangedEvent) => {
        this.props.setServiceTypeId(e.value);
    };

    handleChangeDateFrom = (e: any) => {
        flushSync(() => {
            this.props.setDateFrom(e.value);
        });
    };

    onApplyButtonClicked = () => {
        this.props.onApplyButtonClick();
    };

    render() {
        let disableApplyButton = false;
        if (!this.props.clientId) {
            disableApplyButton = true;
        }
        if (!this.props.venueId) {
            disableApplyButton = true;
        }
        if (!this.props.serviceTypeId) {
            disableApplyButton = true;
        }
        return (
            <div>
                <div className="row mt-4">
                    <div className="col-10">
                        <h4 className="sidebar__heading font-weight-bold">Filter spend</h4>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Client</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <LookupTypeListDynamic
                            lookupTypeIndex={LookupTypeIndexes.clientType}
                            onValueChanged={this.handleChangeClientTypeSelect}
                            isRoot={false}
                            parentMappingId={""}
                            displayExpression={"value"}
                            value={this.props.clientId}
                            recordType={"all"}
                            isDisabled={false}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Venue</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <LookupTypeListDynamic
                            lookupTypeIndex={LookupTypeIndexes.venueType}
                            onValueChanged={this.handleChangeVenueTypeSelect}
                            isRoot={false}
                            parentMappingId={this.props.clientId}
                            value={this.props.venueId}
                            displayExpression={"value"}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Service</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <DropDownFromLookupTableDynamic
                            lookupTypeIndex={LookupTypeIndexes.serviceType}
                            isRoot={true}
                            parentMappingId={"0"}
                            onValueChanged={this.handleChangeServiceTypeSelect}
                            isDisabled={false}
                            value={this.props.serviceTypeId}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col sidebar__heading">Date From</div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <DateBox
                            value={this.props.dateFrom || undefined}
                            onValueChanged={this.handleChangeDateFrom}
                            displayFormat="dd/MM/yyyy"
                            useMaskBehavior={true}
                        />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-6 mx-auto">
                        <Button
                            className="btn btn-primary btn--large"
                            onClick={this.onApplyButtonClicked}
                            disabled={disableApplyButton}
                        >
                            Apply
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(VenueCalendarPageSidebarPanel);
